
import React, { useState } from 'react';
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Card, CardContent } from "./ui/card";
import { motion } from "framer-motion";
import { sendWholesaleEmail } from '../config/smtpConfig';
import { toast } from "sonner";

const WholesaleForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    mensagem: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        const result = await sendWholesaleEmail(formData);
        toast.success(result.message);
        setFormData({ nome: '', telefone: '', email: '', mensagem: '' });
    } catch (error) {
        toast.error("Erro ao enviar mensagem.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <section id="contato" className="py-24 bg-[#FFF8E3] overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-16 items-center">
            <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <h2 className="text-4xl md:text-5xl font-black text-[#E63312] mb-6 uppercase tracking-tight leading-none">Compre no Atacado</h2>
                <div className="w-20 h-1.5 bg-[#FFC300] mb-8 rounded-full"></div>
                <p className="text-lg text-gray-800 mb-8 leading-relaxed font-medium">
                    Agora você pode revender os melhores salgados d'<strong className="text-[#E63312]">O Famoso</strong> com as nossas opções congeladas.
                    <br /><br />
                    Preencha o formulário ao lado com a quantidade que deseja adquirir, que entraremos em contato o mais breve possível.
                </p>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <Card className="shadow-2xl border-none bg-white">
                    <CardContent className="p-8 md:p-12">
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Nome*</label>
                                <Input 
                                    name="nome"
                                    value={formData.nome}
                                    onChange={handleChange}
                                    placeholder="Seu nome completo" 
                                    required 
                                    className="h-12 bg-gray-50 border-gray-200 focus:border-[#E63312] focus:ring-[#E63312] transition-colors"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Telefone*</label>
                                <Input 
                                    name="telefone"
                                    value={formData.telefone}
                                    onChange={handleChange}
                                    placeholder="(00) 00000-0000" 
                                    required 
                                    className="h-12 bg-gray-50 border-gray-200 focus:border-[#E63312] focus:ring-[#E63312] transition-colors"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">E-mail*</label>
                                <Input 
                                    name="email"
                                    type="email" 
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="seu@email.com" 
                                    required
                                    className="h-12 bg-gray-50 border-gray-200 focus:border-[#E63312] focus:ring-[#E63312] transition-colors"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Mensagem*</label>
                                <Textarea 
                                    name="mensagem"
                                    value={formData.mensagem}
                                    onChange={handleChange}
                                    placeholder="Descreva seu pedido ou dúvida..." 
                                    required
                                    className="min-h-[150px] bg-gray-50 border-gray-200 focus:border-[#E63312] focus:ring-[#E63312] transition-colors" 
                                />
                            </div>
                            <Button 
                                type="submit" 
                                disabled={loading}
                                className="w-full bg-[#E63312] hover:bg-black text-white hover:text-[#FFC300] font-bold h-14 text-lg uppercase tracking-wider shadow-lg shadow-red-200 transition-all"
                            >
                                {loading ? "Enviando..." : "ENVIAR SOLICITAÇÃO"}
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WholesaleForm;
